import { render, staticRenderFns } from "./ReAgreeTermModal.vue?vue&type=template&id=19e4b871&"
import script from "./ReAgreeTermModal.vue?vue&type=script&lang=ts&"
export * from "./ReAgreeTermModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports